var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzrx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.282 13.83H2v4.043H23.59c1.382 0 2.17 0 2.17 1.48v4.041c0 1.676-.295 2.465-1.478 2.465-1.183 0-3.845.196-5.127 0-1.025-.159-1.413-.92-1.479-1.283V20.93h-3.944v3.647c-.033.625.178 2.209 1.282 3.55 1.104 1.34 2.76 1.807 3.45 1.873h5.818c.493 0 1.814-.197 3.155-.986 1.34-.789 2.201-2.958 2.464-3.944v-4.732c.133-.953-.018-3.253-1.675-4.83-1.656-1.578-3.319-1.776-3.943-1.677z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.732 2v8.873h3.944V2h-3.944z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBzrx);
export default __webpack_public_path__ + "static/media/BZRX.31ba1383aa6ec50e84654ebfde6056b0.svg";
export { ForwardRef as ReactComponent };